<template>
	<div class="pa-3">
		<v-row class="ma-0" justify="space-between">
			<div class="settings-text row-container">
				Settings
			</div>
			<div id="search-bar" class="row-container">
				<v-menu
					v-model="menu"
					:close-on-content-click="false"
					offset-y
					offset-x
				>
					<template v-slot:activator="{ on, attrs }">
						<v-text-field							
							class="rounded-r-0"
							v-model="search_key"
							:color="color_main"
							background-color="#FFFFFF"
							placeholder="Search"
							outlined
							dense
							hide-details
							disabled	
						>
						</v-text-field>
						<v-btn v-bind="attrs" v-on="on" class="text-capitalize white--text rounded-l-0" min-height="40" depressed color="#605AF6" @click="onSearch" disabled>Search Settings</v-btn>
					</template>
					<v-card v-if="searchList.length !== 0" elevation="0" class="rounded-t-0" :style="`width: ${maxWidth}px;`">
						<v-virtual-scroll
							:items="searchList"
							:height="$vuetify.breakpoint.height - 160"
							item-height="40"
						>
							<template v-slot:default="{ item }">
								<v-list-item :disabled="item.disabled" link :to="item.to">
									<v-list-item-content class="hover-text">
										<v-list-item-title>{{ item.text }}</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</template>
						</v-virtual-scroll>
					</v-card>
					<v-card v-if="searchList.length === 0" elevation="0" class="rounded-t-0" :style="`width: ${maxWidth}px;`">
						<div class="mx-2">no data</div>
					</v-card>
				</v-menu>
			</div>
		</v-row>
		<v-row class="mt-3 mx-0 mb-0">
			<v-tabs
				class="rounded rounded-b-0"
				v-model="tab"
				:color="color_main"
				:show-arrows="$vuetify.breakpoint.smAndDown"
				grow
				center-active
				active-class="active-tab"
				@change="onTabChange"
			>
				<v-tab
					v-for="item in tab_items"
					:key="item.key"
					:disabled="item.disabled"
					class="text-capitalize "
				>
					{{ item.text }}
				</v-tab>
			</v-tabs>
			<v-tabs-items v-model="currentTab" style="width: 100%;" class="rounded rounded-t-0">
				<v-tab-item
					v-for="item in tab_items"
					:key="`content_${item.key}`"
				>
					<v-card v-if="list_key.length === 0 && item.key === 'jobs'" flat class="mx-auto d-flex flex-column flex-wrap rounded rounded-t-0" :class="$vuetify.breakpoint.smAndDown ? 'nowrap':''" style="border-top: thin solid rgba(0, 0, 0, 0.12)" :max-height="$vuetify.breakpoint.smAndDown ? '':$vuetify.breakpoint.height - 180" :min-height="$vuetify.breakpoint.height - 180">
						<div v-for="list_item in jobs_tasks_list" :key="list_item.key">
							<v-divider v-if="list_item.divider"/>
							<v-list-item :disabled="list_item.disabled" link @click="list_key = list_item.key" class="px-1">
								<v-list-item-content>
									<v-list-item-title class="hover-text">{{ list_item.text }}</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</div>
					</v-card>
					<v-card v-if="list_key.length === 0 && item.key === 'administration'" flat class="mx-auto d-flex flex-column flex-wrap rounded rounded-t-0" :class="$vuetify.breakpoint.smAndDown ? 'nowrap':''" style="border-top: thin solid rgba(0, 0, 0, 0.12)" :max-height="$vuetify.breakpoint.smAndDown ? '':$vuetify.breakpoint.height - 180" :min-height="$vuetify.breakpoint.height - 180">
						<div v-for="list_item in temp_list" :key="list_item.key">
							<v-divider v-if="list_item.divider"/>
							<v-list-item :disabled="list_item.disabled" link @click="list_key = list_item.key">
								<v-list-item-content>
									<v-list-item-title class="hover-text">{{ list_item.text }}</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</div>
					</v-card>
					<v-card v-if="list_key === 'taskstatuses' && item.key === 'jobs'" flat class="mx-auto rounded rounded-t-0" style="border-top: thin solid rgba(0, 0, 0, 0.12)" :max-height="$vuetify.breakpoint.height - 180" :min-height="$vuetify.breakpoint.height - 180">
						<TaskStatus
							:color="$attrs.color"
							@close="list_key = ''; is_change = false"
							@change="is_change = $event"
						/>
					</v-card>
					<v-card v-if="list_key === 'jobstatuses' && item.key === 'jobs'" flat class="mx-auto rounded rounded-t-0" style="border-top: thin solid rgba(0, 0, 0, 0.12)" :max-height="$vuetify.breakpoint.height - 180" :min-height="$vuetify.breakpoint.height - 180">
						<JobStatus
							:color="$attrs.color"
							@close="list_key = ''; is_change = false"
							@change="is_change = $event"
						/>
					</v-card>
					<v-card v-if="list_key === 'jobsettings' && item.key === 'jobs'" flat class="mx-auto rounded rounded-t-0" style="border-top: thin solid rgba(0, 0, 0, 0.12)" :max-height="$vuetify.breakpoint.height - 220" :min-height="$vuetify.breakpoint.height - 220">
						<JobSettings
							:color="$attrs.color"
							@close="list_key = ''; is_change = false"
							@change="is_change = $event"
						/>
					</v-card>
					<v-card v-if="list_key === 'eventtypes' && item.key === 'jobs'" flat class="mx-auto rounded rounded-t-0" style="border-top: thin solid rgba(0, 0, 0, 0.12)" :max-height="$vuetify.breakpoint.height - 180" :min-height="$vuetify.breakpoint.height - 180">
						<EventType
							:color="$attrs.color"
							@close="list_key = ''; is_change = false"
							@change="is_change = $event"
						/>
					</v-card>
				</v-tab-item>
			</v-tabs-items>
		</v-row>
		<v-row class="my-0 mx-0" v-if="list_key === 'jobsettings'">
			<v-btn text class="text-capitalize" @click="logs_visible = true">
				<span class="settings-button-text">Settings change log</span>
			</v-btn>
		</v-row>
		<DeleteConfirmDialog 
			v-if="unsaved_visible"
			:visible="unsaved_visible" 
			:color="'error'"
			:title="`Your changes have not been saved`" 
			:content="'Are you sure you want to leave this page without saving changes?'"
			:cancel="'Go back'"
			:ok="'Yes, leave'"
			:icon_name_title="'mdi-alert-circle'"
			:maxWidth="500"
			@cancel="unsaved_visible = false"
			@ok="onLeave()"
		/>
		<v-dialog
			v-if="logs_visible"
			v-model="logs_visible"
			persistent
			:max-width="$vuetify.breakpoint.width <= 1024 ? maxWidth_xs : width"
		>
			<SettingChangeLog
				:color="$attrs.color"
				@close="logs_visible = false"
			/>
		</v-dialog>
	</div>
</template>
<script>
import TaskStatus from '@/views/settings/task/task_status.vue';
import JobStatus from '@/views/settings/job/job_status.vue';
import JobSettings from '@/views/settings/job/job_settings.vue';
import EventType from '@/views/settings/event_type.vue';
import SettingChangeLog from '@/views/settings/setting_change_log.vue';

import DeleteConfirmDialog from "@/components/dialogs/delete_comfirm_dialog.vue";

const COLOR_MAIN = '#605AF6';

const TAB_ITEMS = [
	{
		key: 'jobs',
		text: 'Jobs & Tasks',
		disabled: false
	},
	{
		key: 'administration',
		text: 'Administration',
		disabled: true

	},
	{
		key: 'accounting',
		text: 'Accounting & Finance',
		disabled: true
	},
	{
		key: 'payroll',
		text: 'Payroll',
		disabled: true
	},
	{
		key: 'mysettings',
		text: 'My Settings',
		disabled: true
	}
];

const JobsTasksList = [
	{
		key: 'jobsettings',
		text: 'Job Settings',
		disabled: false,
		divider: false,
		to: "/settings"
	},
	{
		key: 'jobstatuses',
		text: 'Job Statuses',
		disabled: false,
		divider: false,
		to: "/settings"
	},
	{
		key: 'jobtypes',
		text: 'Job Types',
		disabled: true,
		divider: false,
		to: "/settings"
	},
	{
		key: 'jobtemplates',
		text: 'Job Templates',
		disabled: true,
		divider: false,
		to: "/settings"
	},
	{
		key: 'customjobdetailfields',
		text: 'Custom Job Detail Fields',
		disabled: true,
		divider: false,
		to: "/settings"
	},
	{
		key: 'taskstatuses',
		text: 'Task Statuses',
		disabled: false,
		divider: true,
		to: "/settings/taskstatuses"
	},
	{
		key: 'eventtypes',
		text: 'Event Types',
		disabled: false,
		divider: false,
		to: "/settings"
	},
	{
		key: 'timesheetsettings',
		text: 'Timesheet Settings',
		disabled: true,
		divider: false,
		to: "/settings"
	},
	{
		key: 'notetypes',
		text: 'Note Types',
		disabled: true,
		divider: false,
		to: "/settings"
	},
	{
		key: 'documentregistry',
		text: 'Document Registry',
		disabled: true,
		divider: false,
		to: "/settings"
	},
	{
		key: 'keywords',
		text: 'Keywords',
		disabled: true,
		divider: false,
		to: "/settings"
	},
	{
		key: 'kinds',
		text: 'Kinds',
		disabled: true,
		divider: false,
		to: "/settings"
	},
	{
		key: 'organisationchart',
		text: 'Organisation Chart',
		disabled: true,
		divider: true,
		to: "/settings"
	},
	{
		key: 'companiesdivisions',
		text: 'Companies & Divisions',
		disabled: true,
		divider: false,
		to: "/settings"
	},
	{
		key: 'rolespermissions',
		text: 'Roles & Permissions',
		disabled: true,
		divider: false,
		to: "/settings"
	},
	{
		key: 'countries',
		text: 'Countries',
		disabled: true,
		divider: false,
		to: "/settings"
	},
	{
		key: 'datetime',
		text: 'Date & Time',
		disabled: true,
		divider: false,
		to: "/settings"
	},
	{
		key: 'businesshours',
		text: 'Business Hours',
		disabled: true,
		divider: false,
		to: "/settings"
	},
	{
		key: 'publicholidays',
		text: 'Public Holidays',
		disabled: true,
		divider: false,
		to: "/settings/holiday"
	},
	{
		key: 'staffavailability',
		text: 'Staff Availability',
		disabled: true,
		divider: false,
		to: "/settings"
	},
	{
		key: 'planbilling',
		text: 'Plan, Add-ons $ Billing',
		disabled: true,
		divider: true,
		to: "/settings"
	},
	{
		key: 'databasehistory',
		text: 'Database History',
		disabled: true,
		divider: false,
		to: "/settings"
	}
];
const temp_list = [
	{
		key: 'notetypes',
		text: 'Note Types',
		disabled: true,
		divider: false,
		to: "/settings"
	},
	{
		key: 'documentregistry',
		text: 'Document Registry',
		disabled: true,
		divider: false,
		to: "/settings"
	},
]

export default {
	name: 'SettingsView',
	components: {
		TaskStatus,
		JobStatus,
		JobSettings,
		EventType,
		SettingChangeLog,
		DeleteConfirmDialog
	},
	data() {
		this.color_main = COLOR_MAIN;
		this.temp_list = temp_list;

		this.maxWidth_xs = '100%';
		this.width = '800';

		return {
			search_key: '',
			tab: 0,
			currentTab: 0,
			tab_items: TAB_ITEMS,
			next_tab_id: 0,
			jobs_tasks_list: JobsTasksList,
			list_key: '',
			is_change: false,
			unsaved_visible: false,

			menu: false,
			maxWidth: 0,
			entries: [],

			logs_visible: false
		};
	},
	created() {
		this.$store.commit("push_breadcrumb", {
			exact: true,
			text: 'Settings',
			to: this.$route.path
		});
	},
	computed: {
		searchList() {
			let list = [];

			if (this.search_key.length !== 0) {
				const lower_case_text = this.search_key.toLocaleLowerCase();
				
				const list_filter = JobsTasksList.filter(l => { 
					const l_lower_case = l.text.toLocaleLowerCase();
					return l_lower_case.includes(lower_case_text) ;
				});
			
				list = list_filter;
			}

			return list;
		}
	},
	watch: {
		search_key() {
			if (this.search_key.length === 0) {
				this.entries = [];
			}
		}
	},
	methods: {
		onSearch() {
			const elem = document.getElementById("search-bar");
			this.maxWidth = elem.clientWidth;

			this.entries = JobsTasksList;
		},
		onTabChange(tab_id) {
			this.next_tab_id = tab_id;

			if ((this.list_key === 'taskstatuses' || this.list_key === 'jobstatuses' || this.list_key === 'jobsettings' || this.list_key === 'eventtypes') && this.is_change) {
				this.unsaved_visible = true;

				this.$nextTick(() => {
					this.tab = this.currentTab
				})
			} else {
				this.currentTab = this.tab
				this.list_key = '';
			}
		},
		onLeave() {
			this.tab = this.next_tab_id;
			this.currentTab = this.next_tab_id;
			
			this.unsaved_visible = false;
			this.is_change = false;
			this.list_key = '';
		}
	}
}
</script>

<style lang="scss" scoped>
.row-container {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
}

.col-container {
  display: flex;
  flex-flow: column;
  align-items: flex-start;
}
.settings-text {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  color: #192A3E;
}
.settings-button-text {
	font-family: Roboto;
	font-size: 14px;
	font-weight: 500;
	line-height: 36px;
	letter-spacing: 0.5px;
	color: #192A3EB2;
}
.hover-text {
	&:hover {
		color: #605AF6;
	}
}
</style>